<template>
  <Poptip
    placement="bottom-end"
    width="150"
    :options="{
      positionFixed: true,
      modifiers: {
        computeStyle: {
          gpuAcceleration: false,
        },
        preventOverflow: {
          boundariesElement: 'window',
        },
      },
    }"
  >
    <Button type="default">
      筛选列
      <Icon type="ios-arrow-down" />
    </Button>
    <div slot="content">
      <CheckboxGroup class="filter-column" v-model="columnsChecked">
        <Checkbox
          v-for="item in filtercolumn"
          :label="item.key"
          :key="item.key"
        >
          {{ item.title }}
        </Checkbox>
      </CheckboxGroup>
      <div class="all-select">
        <Checkbox
          :indeterminate="
            columnsChecked.length > 0 &&
            columnsChecked.length < filtercolumn.length
          "
          :value="columnsChecked.length === filtercolumn.length"
          @click.prevent.native="columnsCheckedChange"
        >
          全选
        </Checkbox>
      </div>
    </div>
  </Poptip>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'FilterColumn',
  props: {
    column: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll']),
    filtercolumn() {
      return this.column.filter((item) => item.key && item.key.trim())
    },
    columnMapKey() {
      return this.filtercolumn.map((v) => v.key)
    },
    columnsChecked: {
      get() {
        let columnsChecked = this.columnsCheckedAll[this.$route.name] || []
        this.$emit('columnsChecked', columnsChecked)
        return columnsChecked
      },
      set(v) {
        this._columnsCheckedAll({ [this.$route.name]: v })
      },
    },
  },
  methods: {
    ...mapMutations('table', ['_columnsCheckedAll']),
    columnsCheckedChange() {
      if (this.columnsChecked.length === 0) {
        this.columnsChecked = this.columnMapKey
      } else {
        this.columnsChecked = []
      }
    },
  },
}
</script>
<style lang="less">
.all-select {
  border-top: 1px solid #e9e9e9;
  margin-bottom: 1px;
  padding-top: 6px;
  margin-top: 6px;
}
.filter-column {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Base/FilterColumn.vue